import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PhonelinkSetupOutlinedIcon from "@mui/icons-material/PhonelinkSetupOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import ConnectWithoutContactOutlinedIcon from "@mui/icons-material/ConnectWithoutContactOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import CloseIcon from "@mui/icons-material/Close";

const menuItems = [
  { id: 0, link: "/home", icon: <DashboardIcon />, label: "Dashboard" },
  {
    id: 1,
    link: "/home/store-prices",
    icon: <PriceChangeOutlinedIcon />,
    label: "Store Prices",
  },
  {
    id: 2,
    link: "/home/mobile-app",
    icon: <PhonelinkSetupOutlinedIcon />,
    label: "Mobile Integration",
  },
  {
    id: 3,
    link: "/home/customer-profile",
    icon: <BadgeOutlinedIcon />,
    label: "Customer Profile",
  },
  {
    id: 4,
    link: "/home/loyalty-points",
    icon: <AutoAwesomeOutlinedIcon />,
    label: "Loyalty Points",
  },
  {
    id: 5,
    link: "/home/scheme-generation",
    icon: <LocalOfferOutlinedIcon />,
    label: "Scheme Initiation",
  },
  {
    id: 6,
    link: "/home/message-configuration",
    icon: <ConnectWithoutContactOutlinedIcon />,
    label: "Message Configuration",
  },
  {
    id: 7,
    link: "/home/user",
    icon: <ManageAccountsOutlinedIcon />,
    label: "My Profile",
  },
];

const menuItems2 = [
  {
    id: 8,
    link: "/home/statement",
    icon: <LibraryBooksOutlinedIcon />,
    label: "Points Statement",
  },
  {
    id: 9,
    link: "/home/scheme-statement",
    icon: <LibraryBooksOutlinedIcon />,
    label: "Scheme Statement",
  },
  {
    id: 10,
    link: "/home/scheme-summary",
    icon: <AssessmentOutlinedIcon />,
    label: "Scheme Summary",
  },
];

const SideMenu = ({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  toggleMobileMenu,
  closeMobileMenu,
}) => {
  const location = useLocation();
  // Determine if a menu link should be active based on the current URL
  const isActiveLink = (currentPath, link) => {
    if (link === "/home") return currentPath === "/home" || currentPath === "/home/";
    return currentPath === link || currentPath.startsWith(link + "/");
  };
  const navigate = useNavigate();

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        !event.target.closest(".sidebar-container") &&
        !event.target.closest(".mobile-menu-button")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileMenuOpen, setIsMobileMenuOpen]);

  return (
    <>
      {/* Overlay for mobile */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40" />
      )}

      {/* Sidebar */}
      <div
        className={`sidebar-container fixed lg:relative w-[250px] h-full font-mont px-2 bg-primary text-white shadow-custom-medium overflow-y-auto z-50 transition-all duration-300 ease-in-out flex flex-col ${
          isMobileMenuOpen
            ? "translate-x-0"
            : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <div className="flex justify-between items-center">
          <div className="font-semibold px-3 pt-4 text-[22px]">
            Jaina Jewellers
          </div>
          <button
            onClick={closeMobileMenu}
            className="lg:hidden p-2 text-white mt-4 mr-2"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="mt-8 font-mont font-semibold flex-grow">
          {menuItems.map(({ id, link, icon, label }) => (
            <div
              key={id}
              className="mb-2"
              onClick={() => {
                closeMobileMenu();
              }}
            >
              <Link to={link}>
                <div
                  className={`flex items-center px-3 py-2 text-sm rounded-[10px] cursor-pointer hover:bg-second/30 transition-all duration-200 ${
                    isActiveLink(location.pathname, link)
                      ? "bg-second text-primary"
                      : "text-fourth"
                  }`}
                >
                  <div className="mr-3">{icon}</div>
                  <p>{label}</p>
                </div>
              </Link>
            </div>
          ))}

          <div className="border-b my-4 border-gray-600"></div>

          {menuItems2.map(({ id, link, icon, label }) => (
            <div
              key={id}
              className="mb-2"
              onClick={() => {
                closeMobileMenu();
              }}
            >
              <Link to={link}>
                <div
                  className={`flex items-center px-3 py-2 text-sm rounded-[10px] cursor-pointer hover:bg-second/30 transition-all duration-200 ${
                    isActiveLink(location.pathname, link)
                      ? "bg-second text-primary"
                      : "text-fourth"
                  }`}
                >
                  <div className="mr-3">{icon}</div>
                  <p>{label}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-auto">
          <div className="border-b my-4 border-gray-600"></div>

          <div
            onClick={() => {
              localStorage.removeItem("JainaAccessToken");
              localStorage.removeItem("JainaUser");
              navigate("/");
            }}
            className="flex items-center mb-6 px-3 py-2 text-sm rounded-[10px] cursor-pointer hover:bg-second/30 transition-all duration-200"
          >
            <div className="mr-3">
              <LogoutOutlinedIcon />
            </div>
            <p>Logout</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
